import React from 'react';
import { restaurantInfo } from '@/data/menuData';
import { Phone, MapPin, Clock, Wrench } from 'lucide-react';
import OriginalWelcomeScreen from './WelcomeScreenOriginal';

// Maintenance Mode - Set to false to show normal site
const MAINTENANCE_MODE = false;

const MaintenancePage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden bg-gradient-to-b from-charcoal via-charcoal-dark to-black">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
        <div className="absolute top-20 left-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-56 h-56 bg-secondary/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="flex flex-col items-center justify-center px-6 text-center z-10 max-w-lg">
        <div className="relative mb-8 animate-fade-in-up">
          <div className="w-40 h-40 sm:w-48 sm:h-48 rounded-full bg-gradient-to-br from-charcoal-light/90 to-charcoal/90 backdrop-blur-sm border-2 border-primary/40 flex items-center justify-center shadow-gold-lg relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-t from-primary/15 to-transparent" />
            <div className="relative z-10 text-center">
              <span className="font-display text-4xl sm:text-5xl text-gradient-gold tracking-wider">
                gomşu
              </span>
            </div>
          </div>
          <div className="absolute -inset-4 border border-primary/30 rounded-full animate-pulse-gold" />
        </div>

        <h1 className="font-display text-3xl sm:text-4xl text-foreground mb-4 tracking-wide animate-fade-in-up drop-shadow-lg">
          {restaurantInfo.name}
        </h1>

        <div className="mb-6 animate-fade-in-up">
          <div className="w-16 h-16 mx-auto bg-primary/20 rounded-full flex items-center justify-center">
            <Wrench className="w-8 h-8 text-primary animate-pulse" />
          </div>
        </div>

        <div className="bg-charcoal-light/50 backdrop-blur-sm rounded-2xl p-8 border border-primary/20 shadow-gold animate-fade-in-up">
          <h2 className="font-display text-2xl sm:text-3xl text-primary mb-4">
            Çalışma Vardır
          </h2>
          <p className="text-foreground/90 text-lg mb-2">
            Web sitemiz şu anda güncellenmektedir.
          </p>
          <p className="text-foreground/70 text-base mb-6">
            Anlayışınız için teşekkür ederiz.
          </p>

          <div className="w-24 h-0.5 bg-gradient-to-r from-transparent via-primary to-transparent mx-auto mb-6" />

          <div className="space-y-3 text-sm text-foreground/80">
            <div className="flex items-center justify-center gap-3">
              <Phone className="w-4 h-4 text-primary" />
              <a href={`tel:${restaurantInfo.phone}`} className="hover:text-primary transition-colors">
                {restaurantInfo.phone}
              </a>
            </div>
            <div className="flex items-center justify-center gap-3">
              <Clock className="w-4 h-4 text-primary" />
              <span>{restaurantInfo.hours.open} - {restaurantInfo.hours.close}</span>
            </div>
            <div className="flex items-start justify-center gap-3">
              <MapPin className="w-4 h-4 text-primary mt-0.5" />
              <span className="text-center">{restaurantInfo.address}</span>
            </div>
          </div>
        </div>

        <p className="mt-8 text-foreground/50 text-sm animate-fade-in-up">
          En kısa sürede sizinle tekrar buluşacağız
        </p>
      </div>
    </div>
  );
};

const WelcomeScreen = () => {
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }
  return <OriginalWelcomeScreen />;
};

export default WelcomeScreen;
